module.exports = __webpack_public_path__ + "static/media/logo_nerdetcetera_text.496146da.png";